export const ApplicationConfig = {
  showMoreEvents: 10,
  defaultShowUserPaging: 10
};
